import { action, atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export enum OrderStatuses {
  unknown = "Неизвестен",
  done = "Доставлен",
  inTransit = "В пути",
}
export interface IOrderCache {
  orderNo: string;
  status: OrderStatuses;
  trackNo?: string;
}

type CacheRecords = Record<string, IOrderCache>;

export const cacheOrdersAtom = atom<CacheRecords>({}, "cacheOrders").pipe(
  withLocalStorage("cacheOrders"),
);

export const setCacheOrderAtom = action((ctx, data: IOrderCache) => {
  const obj = { ...ctx.get(cacheOrdersAtom) };
  obj[data.orderNo] = data;
  cacheOrdersAtom(ctx, obj);
});
